import React from 'react';
import { useDispatch } from 'react-redux';
import ItfApiForm from '../../../components/Common/TrackedItfApiForm';
import { RouteComponentProps } from 'react-router-dom';
import {
  Spinner,
  Button,
  FieldsMapper,
  RequiredIndicator,
} from '../../../components/Common';
import ApiService from '../../../services/api-service';
import { notifications } from '../../../actions';
import { history } from '../../../App';
import { formOnTranslateString } from '../../../utils/trans-form';
import {
  FormContainer,
  ButtonsContainer,
  CircleWrapper,
} from '../../../components/Layout';
import { ButtonType } from '../../../components/Common/Button';

import './NewPassword.scss';
import { __ } from '../../../services/translation';

interface RouteProps {
  userId: string;
  updateToken: string;
}

interface Props extends RouteComponentProps<RouteProps> {
  userId: string;
  updateToken: string;
}

const NewPassword = ({ match }: Props) => {
  const dispatch = useDispatch();
  return (
    <CircleWrapper
      title={__('application.welcome')}
      subtitle={__('application.new_pass')}
    >
      <FormContainer>
        <ItfApiForm
          formId="reset-password"
          schemaMayBeDynamic={false}
          schemaCacheEnabled
          requiredIndicator={<RequiredIndicator />}
          schemaFetcher={() => ApiService.loadForm('user/form/set-pass')}
          sendFetcher={(formId: string, values: any) => {
            return ApiService.sendForm(
              'user/reset-pass',
              {
                ...values,
                userId: match.params.userId,
                updateToken: match.params.updateToken,
              },
              'PATCH'
            );
          }}
          onSavedSuccessfully={() => {
            dispatch(
              notifications.successNotification('application.new_password_set')
            );
            history.push('/login');
          }}
          loadingInfo={<Spinner transparent />}
          submitButton={
            <ButtonsContainer center padding>
              <Button
                type={ButtonType.Submit}
                primary
                big
                text={'application.submit'}
              />
            </ButtonsContainer>
          }
          onTranslateString={formOnTranslateString}
          onRenderFullField={FieldsMapper}
        />
      </FormContainer>
    </CircleWrapper>
  );
};

export default NewPassword;
